import en from '@/assets/multi_lan/en.json'
import es from '@/assets/multi_lan/es.json'
import ar from '@/assets/multi_lan/ar.json'
import hi from '@/assets/multi_lan/hi.json'
import id from '@/assets/multi_lan/id.json'
import pt from '@/assets/multi_lan/pt.json'
import th from '@/assets/multi_lan/th.json'
import tr from '@/assets/multi_lan/tr.json'
import vi from '@/assets/multi_lan/vi.json'
const lans = {
    'en':en,
    'es':es,
    'ar':ar,
    'hi':hi,
    'id':id,
    'pt':pt,
    'th':th,
    'tr':tr,
    'vi':vi,
}
const lanKeys = ['en', 'tr', 'vi', 'id', 'hi', 'es', 'pt', 'th', 'ar']
const lanValues = [
  'English',
  'Türkçe',
  'Tiếng Việt',
  'Indonesia',
  'हिंदी',
  'Español',
  'Português',
  'ภาษาไทย',
  'بالعربية'
]
const currentLanguage = function(){
   let lan = navigator.language.split('-')[0];
   if(lanKeys.indexOf(lan)===-1){
      lan = 'en';
   }
   // lan = 'ar'
  return lan;
}
function check(){
   for(let k in en){
      for(let key in lans){
         if(lans[key][k]==null){
            console.log(`${en[k]} miss in ${key}`)

         }
      } 
   }
}
if(process.env.NODE_ENV === 'development'){
   check()
}
const multiLan = function(str,...args){

//    var primaryLanguage = navigator.language || navigator.userLanguage
//   let lan = primaryLanguage.split('-')[0];
   let value = lans[currentLanguage()][str];
   // console.log(str,args);
   if(value==null||value===''){
      console.log(`${str} miss in ${currentLanguage()}`);
      return '';
   }
   if(args.length===1){
      value = value.replace('%s',`${args[0]}`);
     value = value.replace('s%',`${args[0]}`);
     for(let i=0;i<args.length;i++){
       value = value.replace('%'+(i+1),`${args[i]}`);
     }
   }else if(args.length>1){
      for(let i=0;i<args.length;i++){
         value = value.replace('%'+(i+1),`${args[i]}`);
      }
   }
   if(value===''||value==null) {
      console.log(`str: ${str} miss`)
      value = '未翻译'
   }
  return value;
}
export{ multiLan,currentLanguage,lanKeys,lanValues};